import { Image, ImageCircleItem, Typography } from '@musinsa/mds';

interface BrandHeaderProps {
  imageUrl: string;
  name: string;
  statusText: string;
  statusColorScheme: string;
}

/** 레거시 CampaignProposalStatus와 동일한 구조. 부모에서 px-4 pt-6 래핑 필요. */
export const BrandHeader = ({
  imageUrl,
  name,
  statusText,
  statusColorScheme,
}: BrandHeaderProps) => (
  <div className="flex gap-3 min-w-0 items-center">
    <ImageCircleItem size="58" type="logo" className="flex-shrink-0">
      <Image src={imageUrl} alt={name} />
    </ImageCircleItem>
    <div className="flex flex-col gap-0.5 flex-1 min-w-0">
      <Typography size="13" weight="semiBold" colorScheme={statusColorScheme}>
        {statusText}
      </Typography>
      <Typography size="13" weight="semiBold" colorScheme="black" className="truncate">
        {name}
      </Typography>
    </div>
  </div>
);
